// extracted by mini-css-extract-plugin
export default {"container":"Callback_container__AI9P9","message":"Callback_message__oEOal"};